<template>
  <v-app>
    <v-dialog v-model="modalStatus" scrollable persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Registrar medidas del paciente</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-dialog
                  ref="dialog"
                  v-model="dateModal"
                  :return-value.sync="formMeasuresPatient.date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formMeasuresPatient.date"
                      label="Fecha"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formMeasuresPatient.date"
                    scrollable
                    first-day-of-week="1"
                    locale="es"
                    :max="maxDate"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dateModal = false">Cancelar</v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog.save(formMeasuresPatient.date)"
                    >Cerrar</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col>
                <v-text-field
                  label="Presión arterial"
                  v-model="formMeasuresPatient.blood_pressure"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field label="Peso" v-model="formMeasuresPatient.weight" />
              </v-col>
              <v-col>
                <v-text-field
                  label="I. M. C."
                  :value="bmi"
                  readonly
                  v-model="formMeasuresPatient.bmi"
                />
              </v-col>
              <v-col>
                <v-text-field label="Cintura" v-model="formMeasuresPatient.waist_1" />
              </v-col>
              <v-col>
                <v-text-field label="Cadera" v-model="formMeasuresPatient.waist_2" />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field label="Grasa total" v-model="formMeasuresPatient.total_fat" />
              </v-col>
              <v-col>
                <v-text-field label="Músculo" v-model="formMeasuresPatient.muscle" />
              </v-col>
              <v-col>
                <v-text-field label="Grasa visceral" v-model="formMeasuresPatient.visceral_fat" />
              </v-col>
              <v-col>
                <v-text-field label="KCal" v-model="formMeasuresPatient.kilocalories" />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field label="Circunferencia de brazo relajado" type="number" v-model="formMeasuresPatient.relaxed_arm_circumference" />
              </v-col>
              <v-col>
                <v-text-field label="Circunferencia de brazo contraído" type="number" v-model="formMeasuresPatient.contracted_arm_circumference" />
              </v-col>
              <v-col>
                <v-text-field label="Tórax" v-model="formMeasuresPatient.chest" type="number" />
              </v-col>
              <v-col>
                <v-text-field label="Muslo" v-model="formMeasuresPatient.thigh" type="number" />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field label="Pantorrilla" v-model="formMeasuresPatient.calf" type="number" />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <tiptap-vuetify
                  v-model="formMeasuresPatient.observations"
                  :extensions="extensions"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="closeModal">Cerrar</v-btn>
          <v-btn color="success" @click="saveMeasures">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import * as moment from "moment";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";
export default {
  name: "Measures",
  components: {
    TiptapVuetify,
  },
  props: ["openModal", "patient"],
  watch: {
    formMeasuresPatient: {
      handler(val) {
        let total = (
          parseFloat(val.weight) / Math.pow(parseFloat(this.patient.height), 2)
        ).toFixed(1);
        if (isNaN(total)) {
          total = 0;
        }
        this.formMeasuresPatient.bmi = total;
      },
      deep: true,
    },
  },
  data() {
    return {
      modalStatus: this.openModal,
      bmi: 0,
      dateModal: false,
      maxDate: moment().format("YYYY-MM-DD"),
      formMeasuresPatient: {
        patient_id: this.patient.id,
        date: moment().format("YYYY-MM-DD"),
      },
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
    };
  },
  methods: {
    closeModal() {
      this.modalStatus = false;
      this.$emit("close-modal");
    },
    saveMeasures() {
      this.openLoader();
      window.setTimeout(() => {
        const request = this.sendRequest(
          this.$store.state.apiUrl +
          "catalogs/patients/" +
          this.formMeasuresPatient.patient_id +
          "/measures",
          this.formMeasuresPatient,
          "POST"
        );
        request
          .then(({ message }) => {
            this.showSuccessMessage(message);
            this.clearForm(this.formMeasuresPatient);
            this.closeModal();
          })
          .finally(this.closeLoader());
      }, 200);
    },
  },
};
</script>
